import React, { useState, useEffect } from 'react';
import './Blog.css';
import './BlogPremium.css';
import Footer from './Footer';
import { 
  FiSearch, FiTrendingUp, FiBookOpen, FiBriefcase, 
  FiFileText, FiZap, FiChevronLeft, FiChevronRight, 
  FiSend, FiTwitter, FiLinkedin, FiYoutube, FiInstagram,
  FiArrowRight, FiActivity
} from 'react-icons/fi';
import { SiReact } from 'react-icons/si';

const Blog = ({ onBack }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');
  
  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 3;

  // Load blogs from localStorage on mount
  useEffect(() => {
    try {
      const savedBlogs = localStorage.getItem('stocks4u_blogs');
      if (savedBlogs) {
        const parsed = JSON.parse(savedBlogs);
        if (Array.isArray(parsed) && parsed.length > 1) {
          setBlogs(parsed);
        } else {
          setDefaultBlog();
        }
      } else {
        setDefaultBlog();
      }
    } catch (error) {
      console.error('Error loading blogs:', error);
      setDefaultBlog();
    }
    setLoading(false);
  }, []);

  const setDefaultBlog = () => {
    const defaultBlogs = [
      {
        id: 1,
        title: "Market Kya Keh Raha Hai?",
        excerpt: "Redefining the user acquisition and redesigned the onboarding experience, all within 3 working weeks.",
        content: "Full content here...",
        date: new Date().toISOString(),
        category: "Info",
        image: "/images/bull_blog.png",
        isFeatured: true
      },
      {
        id: 2,
        title: "Understanding Market Volatility in 2026",
        excerpt: "What's driving the markets this year and how investors can navigate uncertainty.",
        content: "Full content here...",
        date: new Date(Date.now() - 86400000 * 2).toISOString(),
        category: "Market Trends",
        image: null,
        isFeatured: false
      },
      {
        id: 3,
        title: "SIP vs Lump Sum: Which is Better?",
        excerpt: "A comprehensive comparison to help you choose the right investment approach.",
        content: "Full content here...",
        date: new Date(Date.now() - 86400000 * 5).toISOString(),
        category: "Investing 101",
        image: null,
        isFeatured: false
      },
      {
        id: 4,
        title: "How Stocks4U Protects Your Data",
        excerpt: "Security is our priority. Here's how we keep your data safe and private.",
        content: "Full content here...",
        date: new Date(Date.now() - 86400000 * 7).toISOString(),
        category: "Product Updates",
        image: null,
        isFeatured: false
      }
    ];
    setBlogs(defaultBlogs);
    localStorage.setItem('stocks4u_blogs', JSON.stringify(defaultBlogs));
  };

  const handleSubscribe = (e, emailValue, setStatus) => {
    e.preventDefault();
    if (emailValue) {
      const subscribers = JSON.parse(localStorage.getItem('stocks4u_subscribers') || '[]');
      if (!subscribers.includes(emailValue)) {
        subscribers.push(emailValue);
        localStorage.setItem('stocks4u_subscribers', JSON.stringify(subscribers));
        setStatus('Subscribed successfully!');
      } else {
        setStatus('You are already subscribed!');
      }
      setTimeout(() => setStatus(''), 3000);
      setEmail('');
      setNewsletterEmail('');
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  // Helper to estimate read time based on excerpt length as a fallback
  const getReadTime = (blog) => {
    const wordCount = (blog.content || blog.excerpt || '').split(' ').length;
    const readTime = Math.max(1, Math.ceil(wordCount / 200));
    return `${readTime} min read`;
  };

  const featuredBlog = blogs.find(blog => blog.isFeatured) || blogs[0];
  const regularBlogs = blogs.filter(blog => blog.id !== featuredBlog?.id);
  
  // Pagination Logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = regularBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(regularBlogs.length / blogsPerPage);

  const recentSidebarBlogs = regularBlogs.slice(0, 3);

  // Fallback image gradient if no image is provided
  const placeholderGradient = "linear-gradient(135deg, rgba(124, 58, 237, 0.2), rgba(0, 0, 0, 0.8))";

  if (loading) {
    return (
      <div className="blog-page">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'white' }}>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="blog-page">
      {/* Top Navigation */}
      <nav className="blog-navbar">
        <div className="blog-brand">
          <img src="/images/Final Font Stocks4U1.png" alt="Stocks4U Logo" style={{ height: '32px', width: 'auto' }} />
        </div>
        <div className="blog-search-container">
          <FiSearch className="blog-search-icon" />
          <input 
            type="text" 
            className="blog-search-input" 
            placeholder="Search blogs..." 
          />
        </div>
      </nav>

      {/* Breadcrumbs */}
      <div className="blog-breadcrumbs">
        <a href="#blog">Blog</a>
        {featuredBlog && (
          <>
            <span>&gt;</span>
            <span style={{ color: '#fff' }}>{featuredBlog.title}</span>
          </>
        )}
      </div>

      <div className="blog-container">
        {/* Left Column (Main Content) */}
        <div className="blog-main-content">
          
          {/* Hero Section */}
          {featuredBlog && (
            <div className="bp-hero-blog-card">
              <div className="bp-hero-blog-content">
                <span className="bp-hero-badge">{featuredBlog.category?.toUpperCase() || 'INFO'}</span>
                <h1 className="bp-hero-title">{featuredBlog.title}</h1>
                <p className="bp-hero-excerpt">{featuredBlog.excerpt}</p>
                
                <div className="bp-hero-author-meta">
                  <div className="author-avatar">S4</div>
                  <div className="author-info">
                    <span className="author-name">Stocks4U Team</span>
                    <span className="author-date">
                      {formatDate(featuredBlog.date)} &bull; {getReadTime(featuredBlog)}
                    </span>
                  </div>
                </div>
                
                <button className="bp-btn-read-full">Read Full Article</button>
              </div>
              <div className="bp-hero-blog-image">
                {featuredBlog.image ? (
                  <img src={featuredBlog.image} alt={featuredBlog.title} />
                ) : (
                  <div style={{ background: placeholderGradient, width: '100%', height: '100%' }}></div>
                )}
              </div>
            </div>
          )}

          {/* Latest Articles List */}
          <div className="latest-articles-section">
            <div className="section-header">
              <h2 className="section-title">Latest Articles</h2>
              <a href="#view-all" className="view-all-link">View all</a>
            </div>
            
            <div className="latest-articles-list">
              {currentBlogs.length > 0 ? (
                currentBlogs.map((blog) => (
                  <div key={blog.id} className="horizontal-card">
                    <div className="h-card-image">
                      {blog.image ? (
                        <img src={blog.image} alt={blog.title} />
                      ) : (
                        <div style={{ background: placeholderGradient, width: '100%', height: '100%' }}></div>
                      )}
                    </div>
                    <div className="h-card-content">
                      <h3 className="h-card-title">{blog.title}</h3>
                      <p className="h-card-excerpt">{blog.excerpt}</p>
                      <div className="h-card-meta">
                        <span className="h-card-date">
                          {formatDate(blog.date)} &bull; {getReadTime(blog)}
                        </span>
                        <span className="h-card-tag">{blog.category || 'Blog'}</span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ padding: '2rem', textAlign: 'center', color: 'rgba(255,255,255,0.5)' }}>
                  No articles available.
                </div>
              )}
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="pagination">
                <button 
                  className="page-btn"
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                >
                  <FiChevronLeft />
                </button>
                {[...Array(totalPages)].map((_, i) => (
                  <button 
                    key={i} 
                    className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button 
                  className="page-btn"
                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                >
                  <FiChevronRight />
                </button>
              </div>
            )}
          </div>

          {/* Inline Newsletter Banner */}
          <div className="inline-banner">
            <div className="banner-content">
              <div className="banner-icon">
                <FiSend />
              </div>
              <div className="banner-text">
                <h3>Stay Ahead with Stocks4U</h3>
                <p>Join 10,000+ investors who receive our weekly market insights and exclusive updates.</p>
              </div>
            </div>
            <form className="banner-form" onSubmit={(e) => handleSubscribe(e, email, setSubscribeStatus)}>
              <input 
                type="email" 
                className="nl-input-inline" 
                placeholder="Enter your email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="nl-btn-inline">Subscribe</button>
            </form>
            {subscribeStatus && <div style={{ color: '#8B5CF6', fontSize: '0.8rem', marginTop: '0.5rem', position: 'absolute', bottom: '1rem', right: '2rem' }}>{subscribeStatus}</div>}
          </div>

        </div>

        {/* Right Column (Sidebar) */}
        <div className="blog-sidebar">
          
          {/* About Widget */}
          <div className="sidebar-widget about-widget">
            <h3>About Stocks4U</h3>
            <p>Stocks4U is your trusted companion for smarter investing. We simplify complex market trends and help you make confident financial decisions.</p>
            <div className="about-stats">
              <div className="stat-item">
                <span className="stat-value">10K+</span>
                <span className="stat-label">Readers</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">250+</span>
                <span className="stat-label">Articles</span>
              </div>
            </div>
            <button className="btn-outline">
              <FiZap /> Explore Guides <FiArrowRight />
            </button>
          </div>

          {/* Popular Topics Widget */}
          <div className="sidebar-widget topics-widget">
            <h3>Popular Topics</h3>
            <div className="topics-list">
              <a href="#trends" className="topic-item">
                <span className="topic-name"><FiTrendingUp /> Market Trends</span>
                <span className="topic-count">12</span>
              </a>
              <a href="#investing" className="topic-item">
                <span className="topic-name"><FiBookOpen /> Investing 101</span>
                <span className="topic-count">9</span>
              </a>
              <a href="#finance" className="topic-item">
                <span className="topic-name"><FiBriefcase /> Personal Finance</span>
                <span className="topic-count">8</span>
              </a>
              <a href="#analysis" className="topic-item">
                <span className="topic-name"><FiFileText /> Stock Analysis</span>
                <span className="topic-count">7</span>
              </a>
              <a href="#fintech" className="topic-item">
                <span className="topic-name"><FiZap /> Fintech News</span>
                <span className="topic-count">6</span>
              </a>
              <a href="#view-all-topics" className="view-all-link" style={{ marginTop: '0.5rem' }}>View all topics <FiArrowRight style={{ verticalAlign: 'middle' }}/></a>
            </div>
          </div>

          {/* Recent Articles Widget */}
          <div className="sidebar-widget recent-widget">
            <h3>Recent Articles</h3>
            <div className="recent-mini-list">
              {recentSidebarBlogs.length > 0 ? (
                recentSidebarBlogs.map((blog) => (
                  <div key={`sidebar-${blog.id}`} className="recent-mini-card">
                    <div className="rm-image">
                      {blog.image ? (
                        <img src={blog.image} alt={blog.title} />
                      ) : (
                        <div style={{ background: placeholderGradient, width: '100%', height: '100%' }}></div>
                      )}
                    </div>
                    <div className="rm-content">
                      <h4>{blog.title}</h4>
                      <span className="rm-meta">{formatDate(blog.date)} &bull; {getReadTime(blog)}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)' }}>No recent articles.</div>
              )}
            </div>
            <a href="#view-all-articles" className="view-all-link" style={{ display: 'inline-block', marginTop: '1rem' }}>View all articles <FiArrowRight style={{ verticalAlign: 'middle' }}/></a>
          </div>

          {/* Newsletter Widget */}
          <div className="sidebar-widget newsletter-widget">
            <h3>Newsletter</h3>
            <p>Get the latest market insights and fintech updates straight to your inbox.</p>
            <form onSubmit={(e) => handleSubscribe(e, newsletterEmail, setSubscribeStatus)}>
              <input 
                type="email" 
                className="nl-input" 
                placeholder="Enter your email" 
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                required
              />
              <button type="submit" className="nl-btn">Subscribe</button>
            </form>
            <p className="nl-hint">No spam. Unsubscribe anytime.</p>
            {subscribeStatus && <div style={{ color: '#8B5CF6', fontSize: '0.8rem', marginTop: '0.5rem' }}>{subscribeStatus}</div>}
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blog;
